import { ParagraphItem } from '../Card';
import React from 'react';

import { QuestionItemsFragment } from '../../generated/graphql';
import { questionItemRoute } from '../../helpers/routes';
import { PageItemLink } from '../PageItemLink';
import { ItemProps } from './common';

const Question: React.FC<ItemProps> = ({ item, page, className, dragProps, preview }) => {
  const { id, question, answer } = item as QuestionItemsFragment;

  return (
    <PageItemLink
      to={questionItemRoute(page.id, id, preview)}
      page={page}
      pageItem={item}
      data-testid={`question-item-${id}`}
    >
      <ParagraphItem header={question} text={answer} className={className} {...dragProps} />
    </PageItemLink>
  );
};

export default Question;
